// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { getBusOwners } from '../../Services/Operations/ProductAPI';

// // Skeleton Components
// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Bus Number</th>
//           <th>Bus Name</th>
//           <th>Bus Type</th>
//           <th>Category</th>
//           <th>Total Seats</th>
//           <th>Available Seats</th>
//           <th>Owner Name</th>
//           <th>Owner Phone</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const BusManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [allBusesData, setAllBusesData] = useState([]); // Store all buses
//   const [filteredBuses, setFilteredBuses] = useState([]); // Filtered buses based on search
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewingBus, setViewingBus] = useState(null);
  
//   // Pagination states for buses
//   const [currentPage, setCurrentPage] = useState(1);
//   const [busesPerPage] = useState(10);
  
//   // Stats
//   const [totalBusesCount, setTotalBusesCount] = useState(0);
//   const [totalOwnersCount, setTotalOwnersCount] = useState(0);

//   // Fetch all bus owners (all pages) on component mount
//   useEffect(() => {
//     fetchAllBusOwners();
//   }, []);

//   // Filter buses when search term changes
//   useEffect(() => {
//     if (searchTerm.trim() === '') {
//       setFilteredBuses(allBusesData);
//     } else {
//       const searchLower = searchTerm.toLowerCase();
//       const filtered = allBusesData.filter(bus => 
//         bus.busNumber.toLowerCase().includes(searchLower) ||
//         bus.busName.toLowerCase().includes(searchLower) ||
//         bus.ownerName.toLowerCase().includes(searchLower) ||
//         bus.ownerPhone.includes(searchLower)
//       );
//       setFilteredBuses(filtered);
//     }
//     setCurrentPage(1); // Reset to first page when search changes
//   }, [searchTerm, allBusesData]);

//   const fetchAllBusOwners = async () => {
//     try {
//       setLoading(true);
//       let allOwners = [];
//       let currentPageNum = 1;
//       let totalPages = 1;
      
//       // Fetch all pages of bus owners
//       do {
//         const response = await getBusOwners(token, currentPageNum, 10, '');
        
//         if (response && response.success && response.busOwners) {
//           allOwners = [...allOwners, ...response.busOwners];
//           totalPages = response.totalPages;
//           setTotalOwnersCount(response.total);
//           currentPageNum++;
//         } else {
//           break;
//         }
//       } while (currentPageNum <= totalPages);
      
//       // Extract all buses from all owners
//       const buses = [];
//       allOwners.forEach(owner => {
//         if (owner.busAll && owner.busAll.length > 0) {
//           owner.busAll.forEach(bus => {
//             buses.push({
//               id: bus._id,
//               busNumber: bus.busNumber,
//               busName: bus.busName,
//               busType: bus.busType,
//               busCategory: bus.busCategory,
//               totalSeats: bus.totalSeats,
//               availableSeats: bus.availableSeats,
//               amenities: bus.amenities || [],
//               operatingDays: bus.operatingDays || [],
//               isActive: bus.isActive,
//               driver: bus.driver,
//               conductor: bus.conductor,
//               ownerId: owner._id,
//               ownerName: owner.name,
//               ownerPhone: owner.phone,
//               ownerEmail: owner.email,
//               ownerCompany: owner.companyName,
//               ownerAddress: owner.address,
//               ownerCommissionRate: owner.commissionRate,
//               ownerCommissionType: owner.commissionType,
//               ownerIsVerified: owner.isVerified,
//               ownerIsApproved: owner.isApprovedByAdmin
//             });
//           });
//         }
//       });
      
//       setAllBusesData(buses);
//       setFilteredBuses(buses);
//       setTotalBusesCount(buses.length);
      
//     } catch (err) {
//       console.error('Error fetching bus owners:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Get current buses for pagination
//   const indexOfLastBus = currentPage * busesPerPage;
//   const indexOfFirstBus = indexOfLastBus - busesPerPage;
//   const currentBuses = filteredBuses.slice(indexOfFirstBus, indexOfLastBus);
//   const totalPages = Math.ceil(filteredBuses.length / busesPerPage);

//   // Add serial numbers to current buses
//   const currentBusesWithSerial = currentBuses.map((bus, index) => ({
//     ...bus,
//     serialNo: indexOfFirstBus + index + 1
//   }));

//   const handleViewBus = (bus) => {
//     setViewingBus(bus);
//   };

//   const closeViewModal = () => {
//     setViewingBus(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const handleRefresh = async () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     await fetchAllBusOwners(); // Refresh all data
//   };

//   const handleExportCSV = () => {
//     if (filteredBuses.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Serial No.', 'Bus Number', 'Bus Name', 'Bus Type', 'Category', 
//                      'Total Seats', 'Available Seats', 'Owner Name', 'Owner Phone', 
//                      'Owner Company', 'Status'];
//     const csvData = filteredBuses.map((bus, index) => [
//       index + 1,
//       bus.busNumber,
//       bus.busName,
//       bus.busType,
//       bus.busCategory,
//       bus.totalSeats,
//       bus.availableSeats,
//       bus.ownerName || 'N/A',
//       bus.ownerPhone || 'N/A',
//       bus.ownerCompany || 'N/A',
//       bus.isActive ? 'Active' : 'Inactive'
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `buses-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Calculate stats
//   const activeBuses = filteredBuses.filter(bus => bus.isActive).length;
//   const totalSeats = filteredBuses.reduce((sum, bus) => sum + (bus.totalSeats || 0), 0);
//   const uniqueBusOwners = new Set(filteredBuses.map(bus => bus.ownerId)).size;

//   // Loading state with skeletons
//   if (loading && allBusesData.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Bus Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search by bus number, name, owner name or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "300px" }}
//             />
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Buses</h3>
//           <p>{totalBusesCount}</p>
//           <span>All registered buses</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Buses</h3>
//           <p>{activeBuses}</p>
//           <span>Currently active</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Seats</h3>
//           <p>{totalSeats}</p>
//           <span>Across all buses</span>
//         </div>
//         <div className="stat-card">
//           <h3>Bus Owners</h3>
//           <p>{uniqueBusOwners}</p>
//           <span>Unique owners</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Bus Number</th>
//               <th>Bus Name</th>
//               <th>Bus Type</th>
//               <th>Category</th>
//               <th>Total Seats</th>
//               <th>Available Seats</th>
//               <th>Owner Name</th>
//               <th>Owner Phone</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentBusesWithSerial.length > 0 ? (
//               currentBusesWithSerial.map(bus => (
//                 <tr key={bus.id}>
//                   <td>{bus.serialNo}</td>
//                   <td>
//                     <span style={{ fontWeight: '600', color: '#0f6fbf' }}>
//                       {bus.busNumber}
//                     </span>
//                   </td>
//                   <td>{bus.busName}</td>
//                   <td>
//                     <span className={`bus-type-badge ${bus.busType === 'AC' ? 'ac' : 'non-ac'}`}>
//                       {bus.busType}
//                     </span>
//                   </td>
//                   <td>
//                     <span className="bus-category-badge">
//                       {bus.busCategory}
//                     </span>
//                   </td>
//                   <td>{bus.totalSeats}</td>
//                   <td>{bus.availableSeats}</td>
//                   <td>
//                     <div>
//                       <strong>{bus.ownerName}</strong>
//                       {bus.ownerCompany && (
//                         <div style={{ fontSize: '12px', color: '#666' }}>
//                           {bus.ownerCompany}
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                   <td>{bus.ownerPhone}</td>
//                   <td>
//                     <span className={`status-badge ${bus.isActive ? 'active' : 'inactive'}`}>
//                       {bus.isActive ? 'Active' : 'Inactive'}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewBus(bus)}
//                       >
//                         View
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" className="no-data">
//                   <p>No buses found {searchTerm ? 'matching your search' : ''}.</p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all buses
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination Component */}
//       {filteredBuses.length > 0 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {indexOfFirstBus + 1} to {Math.min(indexOfLastBus, filteredBuses.length)} of {filteredBuses.length} buses
//             {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="pagination-btn"
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>

//             <div className="page-numbers">
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let pageNumber;
//                 if (totalPages <= 5) {
//                   pageNumber = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNumber = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNumber = totalPages - 4 + i;
//                 } else {
//                   pageNumber = currentPage - 2 + i;
//                 }

//                 return (
//                   <button
//                     key={pageNumber}
//                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                     onClick={() => handlePageClick(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 );
//               })}
//             </div>

//             <button
//               className="pagination-btn"
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       {/* View Bus Modal */}
//       {viewingBus && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1 view-route-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bus Details: {viewingBus.busNumber}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>

//             <div className="modal-body view-modal-body">
//               <div className="route-details">
//                 {/* Bus Basic Information */}
//                 <div className="detail-section">
//                   <h4>Bus Information</h4>
//                   <div className="detail-row">
//                     <label>Bus Number:</label>
//                     <span style={{ fontWeight: 'bold', color: '#007bff' }}>{viewingBus.busNumber}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Name:</label>
//                     <span>{viewingBus.busName}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Type:</label>
//                     <span className={`bus-type-badge ${viewingBus.busType === 'AC' ? 'ac' : 'non-ac'}`}>
//                       {viewingBus.busType}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Category:</label>
//                     <span>{viewingBus.busCategory}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Total Seats:</label>
//                     <span>{viewingBus.totalSeats}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Available Seats:</label>
//                     <span>{viewingBus.availableSeats}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Status:</label>
//                     <span className={`status-badge ${viewingBus.isActive ? 'active' : 'inactive'}`}>
//                       {viewingBus.isActive ? 'Active' : 'Inactive'}
//                     </span>
//                   </div>
//                 </div>

//                 {/* Amenities */}
//                 {viewingBus.amenities && viewingBus.amenities.length > 0 && (
//                   <div className="detail-section">
//                     <h4>Amenities</h4>
//                     <div className="amenities-list">
//                       {viewingBus.amenities.map((amenity, index) => (
//                         <span key={index} className="amenity-badge">
//                           {amenity}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Operating Days */}
//                 {viewingBus.operatingDays && viewingBus.operatingDays.length > 0 && (
//                   <div className="detail-section">
//                     <h4>Operating Days</h4>
//                     <div className="operating-days-list">
//                       {viewingBus.operatingDays.map((day, index) => (
//                         <span key={index} className="day-badge">
//                           {day}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Driver Information */}
//                 {viewingBus.driver && (
//                   <div className="detail-section">
//                     <h4>Driver Information</h4>
//                     <div className="detail-row">
//                       <label>Driver Name:</label>
//                       <span>{viewingBus.driver.name || 'N/A'}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Driver Phone:</label>
//                       <span>{viewingBus.driver.mobileNumber || 'N/A'}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>License Number:</label>
//                       <span>{viewingBus.driver.licenseNumber || 'N/A'}</span>
//                     </div>
//                   </div>
//                 )}

//                 {/* Conductor Information */}
//                 {viewingBus.conductor && (
//                   <div className="detail-section">
//                     <h4>Conductor Information</h4>
//                     <div className="detail-row">
//                       <label>Conductor Name:</label>
//                       <span>{viewingBus.conductor.name || 'N/A'}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Conductor Phone:</label>
//                       <span>{viewingBus.conductor.mobileNumber || 'N/A'}</span>
//                     </div>
//                   </div>
//                 )}

//                 {/* Owner Information */}
//                 <div className="detail-section">
//                   <h4>Owner Information</h4>
//                   <div className="detail-row">
//                     <label>Owner Name:</label>
//                     <span><strong>{viewingBus.ownerName}</strong></span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Phone Number:</label>
//                     <span>{viewingBus.ownerPhone}</span>
//                   </div>
//                   {viewingBus.ownerEmail && (
//                     <div className="detail-row">
//                       <label>Email:</label>
//                       <span>{viewingBus.ownerEmail}</span>
//                     </div>
//                   )}
//                   {viewingBus.ownerCompany && (
//                     <div className="detail-row">
//                       <label>Company:</label>
//                       <span>{viewingBus.ownerCompany}</span>
//                     </div>
//                   )}
//                   {viewingBus.ownerAddress && (
//                     <div className="detail-row">
//                       <label>Address:</label>
//                       <span>
//                         {viewingBus.ownerAddress.city}, {viewingBus.ownerAddress.state}
//                         {viewingBus.ownerAddress.pincode && ` - ${viewingBus.ownerAddress.pincode}`}
//                       </span>
//                     </div>
//                   )}
//                   <div className="detail-row">
//                     <label>Commission:</label>
//                     <span>{viewingBus.ownerCommissionRate}% ({viewingBus.ownerCommissionType})</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Verification Status:</label>
//                     <span className={`status-badge ${viewingBus.ownerIsVerified ? 'active' : 'inactive'}`}>
//                       {viewingBus.ownerIsVerified ? 'Verified' : 'Unverified'}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Admin Approval:</label>
//                     <span className={`status-badge ${viewingBus.ownerIsApproved ? 'active' : 'inactive'}`}>
//                       {viewingBus.ownerIsApproved ? 'Approved' : 'Pending'}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BusManagement;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { getBusOwners } from '../../Services/Operations/ProductAPI';
// import LiveSeatStatusModal from './LiveSeatStatusModal';

// // Skeleton Components
// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Bus Number</th>
//           <th>Bus Name</th>
//           <th>Bus Type</th>
//           <th>Category</th>
//           <th>Total Seats</th>
//           <th>Available Seats</th>
//           <th>Owner Name</th>
//           <th>Owner Phone</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const BusManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [allBusesData, setAllBusesData] = useState([]); // Store all buses
//   const [filteredBuses, setFilteredBuses] = useState([]); // Filtered buses based on search
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewingBus, setViewingBus] = useState(null);
//   const [seatStatusBus, setSeatStatusBus] = useState(null); // Bus selected for Live Seat Status modal

//   // Pagination states for buses
//   const [currentPage, setCurrentPage] = useState(1);
//   const [busesPerPage] = useState(10);

//   // Stats
//   const [totalBusesCount, setTotalBusesCount] = useState(0);
//   const [totalOwnersCount, setTotalOwnersCount] = useState(0);

//   // Fetch all bus owners (all pages) on component mount
//   useEffect(() => {
//     fetchAllBusOwners();
//   }, []);

//   // Filter buses when search term changes
//   useEffect(() => {
//     if (searchTerm.trim() === '') {
//       setFilteredBuses(allBusesData);
//     } else {
//       const searchLower = searchTerm.toLowerCase();
//       const filtered = allBusesData.filter(bus =>
//         bus.busNumber.toLowerCase().includes(searchLower) ||
//         bus.busName.toLowerCase().includes(searchLower) ||
//         bus.ownerName.toLowerCase().includes(searchLower) ||
//         bus.ownerPhone.includes(searchLower)
//       );
//       setFilteredBuses(filtered);
//     }
//     setCurrentPage(1); // Reset to first page when search changes
//   }, [searchTerm, allBusesData]);

//   const fetchAllBusOwners = async () => {
//     try {
//       setLoading(true);
//       let allOwners = [];
//       let currentPageNum = 1;
//       let totalPages = 1;

//       // Fetch all pages of bus owners
//       do {
//         const response = await getBusOwners(token, currentPageNum, 10, '');
// console.log("getBusOwners ::::::::: ",response)
//         if (response && response.success && response.busOwners) {
//           allOwners = [...allOwners, ...response.busOwners];
//           totalPages = response.totalPages;
//           setTotalOwnersCount(response.total);
//           currentPageNum++;
//         } else {
//           break;
//         }
//       } while (currentPageNum <= totalPages);

//       // Extract all buses from all owners
//       const buses = [];
//       allOwners.forEach(owner => {
//         if (owner.busAll && owner.busAll.length > 0) {
//           owner.busAll.forEach(bus => {
//             buses.push({
//               id: bus._id,
//               busNumber: bus.busNumber,
//               busName: bus.busName,
//               busType: bus.busType,
//               busCategory: bus.busCategory,
//               totalSeats: bus.totalSeats,
//               availableSeats: bus.availableSeats,
//               amenities: bus.amenities || [],
//               operatingDays: bus.operatingDays || [],
//               isActive: bus.isActive,
//               driver: bus.driver,
//               conductor: bus.conductor,
//               seats: bus.seats || [], // Static seat layout, used by Live Seat Status modal
//               ownerId: owner._id,
//               ownerName: owner.name,
//               ownerPhone: owner.phone,
//               ownerEmail: owner.email,
//               ownerCompany: owner.companyName,
//               ownerAddress: owner.address,
//               ownerCommissionRate: owner.commissionRate,
//               ownerCommissionType: owner.commissionType,
//               ownerIsVerified: owner.isVerified,
//               ownerIsApproved: owner.isApprovedByAdmin
//             });
//           });
//         }
//       });

//       setAllBusesData(buses);
//       setFilteredBuses(buses);
//       setTotalBusesCount(buses.length);

//     } catch (err) {
//       console.error('Error fetching bus owners:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Get current buses for pagination
//   const indexOfLastBus = currentPage * busesPerPage;
//   const indexOfFirstBus = indexOfLastBus - busesPerPage;
//   const currentBuses = filteredBuses.slice(indexOfFirstBus, indexOfLastBus);
//   const totalPages = Math.ceil(filteredBuses.length / busesPerPage);

//   // Add serial numbers to current buses
//   const currentBusesWithSerial = currentBuses.map((bus, index) => ({
//     ...bus,
//     serialNo: indexOfFirstBus + index + 1
//   }));

//   const handleViewBus = (bus) => {
//     setViewingBus(bus);
//   };

//   const closeViewModal = () => {
//     setViewingBus(null);
//   };

//   const handleOpenSeatStatus = (bus) => {
//     setSeatStatusBus(bus);
//   };

//   const closeSeatStatusModal = () => {
//     setSeatStatusBus(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const handleRefresh = async () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     await fetchAllBusOwners(); // Refresh all data
//   };

//   const handleExportCSV = () => {
//     if (filteredBuses.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Serial No.', 'Bus Number', 'Bus Name', 'Bus Type', 'Category',
//                      'Total Seats', 'Available Seats', 'Owner Name', 'Owner Phone',
//                      'Owner Company', 'Status'];
//     const csvData = filteredBuses.map((bus, index) => [
//       index + 1,
//       bus.busNumber,
//       bus.busName,
//       bus.busType,
//       bus.busCategory,
//       bus.totalSeats,
//       bus.availableSeats,
//       bus.ownerName || 'N/A',
//       bus.ownerPhone || 'N/A',
//       bus.ownerCompany || 'N/A',
//       bus.isActive ? 'Active' : 'Inactive'
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `buses-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Calculate stats
//   const activeBuses = filteredBuses.filter(bus => bus.isActive).length;
//   const totalSeats = filteredBuses.reduce((sum, bus) => sum + (bus.totalSeats || 0), 0);
//   const uniqueBusOwners = new Set(filteredBuses.map(bus => bus.ownerId)).size;

//   // Loading state with skeletons
//   if (loading && allBusesData.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Bus Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search by bus number, name, owner name or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "300px" }}
//             />
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Buses</h3>
//           <p>{totalBusesCount}</p>
//           <span>All registered buses</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Buses</h3>
//           <p>{activeBuses}</p>
//           <span>Currently active</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Seats</h3>
//           <p>{totalSeats}</p>
//           <span>Across all buses</span>
//         </div>
//         <div className="stat-card">
//           <h3>Bus Owners</h3>
//           <p>{uniqueBusOwners}</p>
//           <span>Unique owners</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Bus Number</th>
//               <th>Bus Name</th>
//               <th>Bus Type</th>
//               <th>Category</th>
//               <th>Total Seats</th>
//               <th>Available Seats</th>
//               <th>Owner Name</th>
//               <th>Owner Phone</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentBusesWithSerial.length > 0 ? (
//               currentBusesWithSerial.map(bus => (
//                 <tr key={bus.id}>
//                   <td>{bus.serialNo}</td>
//                   <td>
//                     <span style={{ fontWeight: '600', color: '#0f6fbf' }}>
//                       {bus.busNumber}
//                     </span>
//                   </td>
//                   <td>{bus.busName}</td>
//                   <td>
//                     <span className={`bus-type-badge ${bus.busType === 'AC' ? 'ac' : 'non-ac'}`}>
//                       {bus.busType}
//                     </span>
//                   </td>
//                   <td>
//                     <span className="bus-category-badge">
//                       {bus.busCategory}
//                     </span>
//                   </td>
//                   <td>{bus.totalSeats}</td>
//                   <td>
//                     <div className="available-seats-cell">
                    
//                       <button
//                         className="action-btn live-seat-btn"
//                         onClick={() => handleOpenSeatStatus(bus)}
//                         title="View live seat status for a selected date"
//                         style={{ backgroundColor: "#808080" }}
//                       >
//                         Live Seat Status
//                       </button>
//                     </div>
//                   </td>
//                   <td>
//                     <div>
//                       <strong>{bus.ownerName}</strong>
//                       {bus.ownerCompany && (
//                         <div style={{ fontSize: '12px', color: '#666' }}>
//                           {bus.ownerCompany}
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                   <td>{bus.ownerPhone}</td>
//                   <td>
//                     <span className={`status-badge ${bus.isActive ? 'active' : 'inactive'}`}>
//                       {bus.isActive ? 'Active' : 'Inactive'}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewBus(bus)}
//                       >
//                         View
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" className="no-data">
//                   <p>No buses found {searchTerm ? 'matching your search' : ''}.</p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all buses
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination Component */}
//       {filteredBuses.length > 0 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {indexOfFirstBus + 1} to {Math.min(indexOfLastBus, filteredBuses.length)} of {filteredBuses.length} buses
//             {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="pagination-btn"
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>

//             <div className="page-numbers">
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let pageNumber;
//                 if (totalPages <= 5) {
//                   pageNumber = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNumber = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNumber = totalPages - 4 + i;
//                 } else {
//                   pageNumber = currentPage - 2 + i;
//                 }

//                 return (
//                   <button
//                     key={pageNumber}
//                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                     onClick={() => handlePageClick(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 );
//               })}
//             </div>

//             <button
//               className="pagination-btn"
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       {/* View Bus Modal */}
//       {viewingBus && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1 view-route-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bus Details: {viewingBus.busNumber}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>

//             <div className="modal-body view-modal-body">
//               <div className="route-details">
//                 {/* Bus Basic Information */}
//                 <div className="detail-section">
//                   <h4>Bus Information</h4>
//                   <div className="detail-row">
//                     <label>Bus Number:</label>
//                     <span style={{ fontWeight: 'bold', color: '#007bff' }}>{viewingBus.busNumber}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Name:</label>
//                     <span>{viewingBus.busName}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Type:</label>
//                     <span className={`bus-type-badge ${viewingBus.busType === 'AC' ? 'ac' : 'non-ac'}`}>
//                       {viewingBus.busType}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Category:</label>
//                     <span>{viewingBus.busCategory}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Total Seats:</label>
//                     <span>{viewingBus.totalSeats}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Available Seats:</label>
//                     <span>{viewingBus.availableSeats}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Status:</label>
//                     <span className={`status-badge ${viewingBus.isActive ? 'active' : 'inactive'}`}>
//                       {viewingBus.isActive ? 'Active' : 'Inactive'}
//                     </span>
//                   </div>
//                 </div>

//                 {/* Amenities */}
//                 {viewingBus.amenities && viewingBus.amenities.length > 0 && (
//                   <div className="detail-section">
//                     <h4>Amenities</h4>
//                     <div className="amenities-list">
//                       {viewingBus.amenities.map((amenity, index) => (
//                         <span key={index} className="amenity-badge">
//                           {amenity}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Operating Days */}
//                 {viewingBus.operatingDays && viewingBus.operatingDays.length > 0 && (
//                   <div className="detail-section">
//                     <h4>Operating Days</h4>
//                     <div className="operating-days-list">
//                       {viewingBus.operatingDays.map((day, index) => (
//                         <span key={index} className="day-badge">
//                           {day}
//                         </span>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* Driver Information */}
//                 {viewingBus.driver && (
//                   <div className="detail-section">
//                     <h4>Driver Information</h4>
//                     <div className="detail-row">
//                       <label>Driver Name:</label>
//                       <span>{viewingBus.driver.name || 'N/A'}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Driver Phone:</label>
//                       <span>{viewingBus.driver.mobileNumber || 'N/A'}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>License Number:</label>
//                       <span>{viewingBus.driver.licenseNumber || 'N/A'}</span>
//                     </div>
//                   </div>
//                 )}

//                 {/* Conductor Information */}
//                 {viewingBus.conductor && (
//                   <div className="detail-section">
//                     <h4>Conductor Information</h4>
//                     <div className="detail-row">
//                       <label>Conductor Name:</label>
//                       <span>{viewingBus.conductor.name || 'N/A'}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Conductor Phone:</label>
//                       <span>{viewingBus.conductor.mobileNumber || 'N/A'}</span>
//                     </div>
//                   </div>
//                 )}

//                 {/* Owner Information */}
//                 <div className="detail-section">
//                   <h4>Owner Information</h4>
//                   <div className="detail-row">
//                     <label>Owner Name:</label>
//                     <span><strong>{viewingBus.ownerName}</strong></span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Phone Number:</label>
//                     <span>{viewingBus.ownerPhone}</span>
//                   </div>
//                   {viewingBus.ownerEmail && (
//                     <div className="detail-row">
//                       <label>Email:</label>
//                       <span>{viewingBus.ownerEmail}</span>
//                     </div>
//                   )}
//                   {viewingBus.ownerCompany && (
//                     <div className="detail-row">
//                       <label>Company:</label>
//                       <span>{viewingBus.ownerCompany}</span>
//                     </div>
//                   )}
//                   {viewingBus.ownerAddress && (
//                     <div className="detail-row">
//                       <label>Address:</label>
//                       <span>
//                         {viewingBus.ownerAddress.city}, {viewingBus.ownerAddress.state}
//                         {viewingBus.ownerAddress.pincode && ` - ${viewingBus.ownerAddress.pincode}`}
//                       </span>
//                     </div>
//                   )}
//                   <div className="detail-row">
//                     <label>Commission:</label>
//                     <span>{viewingBus.ownerCommissionRate}% ({viewingBus.ownerCommissionType})</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Verification Status:</label>
//                     <span className={`status-badge ${viewingBus.ownerIsVerified ? 'active' : 'inactive'}`}>
//                       {viewingBus.ownerIsVerified ? 'Verified' : 'Unverified'}
//                     </span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Admin Approval:</label>
//                     <span className={`status-badge ${viewingBus.ownerIsApproved ? 'active' : 'inactive'}`}>
//                       {viewingBus.ownerIsApproved ? 'Approved' : 'Pending'}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Live Seat Status Modal */}
//       {seatStatusBus && (
//         <LiveSeatStatusModal
//           bus={seatStatusBus}
//           token={token}
//           onClose={closeSeatStatusModal}
//         />
//       )}
//     </div>
//   );
// };

// export default BusManagement;

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import '../../Styles/CustomerManage.css';
import { getBusOwners } from '../../Services/Operations/ProductAPI';
import LiveSeatStatusModal from './LiveSeatStatusModal';

// Skeleton Components
const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>No.</th>
          <th>Bus Number</th>
          <th>Bus Name</th>
          <th>Bus Type</th>
          <th>Category</th>
          <th>Total Seats</th>
          <th>Available Seats</th>
          <th>Owner Name</th>
          <th>Owner Phone</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const BusManagement = () => {
  const { token } = useSelector(state => state.user);
  const [allBusesData, setAllBusesData] = useState([]);
  const [filteredBuses, setFilteredBuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewingBus, setViewingBus] = useState(null);
  const [seatStatusBus, setSeatStatusBus] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [busesPerPage] = useState(10);

  const [totalBusesCount, setTotalBusesCount] = useState(0);
  const [totalOwnersCount, setTotalOwnersCount] = useState(0);

  useEffect(() => {
    fetchAllBusOwners();
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredBuses(allBusesData);
    } else {
      const searchLower = searchTerm.toLowerCase();
      const filtered = allBusesData.filter(bus =>
        bus.busNumber.toLowerCase().includes(searchLower) ||
        bus.busName.toLowerCase().includes(searchLower) ||
        bus.ownerName.toLowerCase().includes(searchLower) ||
        bus.ownerPhone.includes(searchLower)
      );
      setFilteredBuses(filtered);
    }
    setCurrentPage(1);
  }, [searchTerm, allBusesData]);

  const fetchAllBusOwners = async () => {
    try {
      setLoading(true);
      let allOwners = [];
      let currentPageNum = 1;
      let totalPages = 1;

      do {
        const response = await getBusOwners(token, currentPageNum, 10, '');
        console.log("getBusOwners ::::::::: ", response);
        if (response && response.success && response.busOwners) {
          allOwners = [...allOwners, ...response.busOwners];
          totalPages = response.totalPages;
          setTotalOwnersCount(response.total);
          currentPageNum++;
        } else {
          break;
        }
      } while (currentPageNum <= totalPages);

      const buses = [];
      allOwners.forEach(owner => {
        if (owner.busAll && owner.busAll.length > 0) {
          owner.busAll.forEach(bus => {
            buses.push({
              // Pass ALL bus data for Live Seat Status Modal
              ...bus, // This includes routeSchedules, seats, etc.
              id: bus._id,
              busNumber: bus.busNumber,
              busName: bus.busName,
              busType: bus.busType,
              busCategory: bus.busCategory,
              totalSeats: bus.totalSeats,
              availableSeats: bus.availableSeats,
              amenities: bus.amenities || [],
              operatingDays: bus.operatingDays || [],
              isActive: bus.isActive,
              driver: bus.driver,
              conductor: bus.conductor,
              seats: bus.seats || [],
              routeSchedules: bus.routeSchedules || [], // IMPORTANT: Pass routeSchedules
              seatConfiguration: bus.seatConfiguration || {},
              ownerId: owner._id,
              ownerName: owner.name,
              ownerPhone: owner.phone,
              ownerEmail: owner.email,
              ownerCompany: owner.companyName,
              ownerAddress: owner.address,
              ownerCommissionRate: owner.commissionRate,
              ownerCommissionType: owner.commissionType,
              ownerIsVerified: owner.isVerified,
              ownerIsApproved: owner.isApprovedByAdmin
            });
          });
        }
      });

      setAllBusesData(buses);
      setFilteredBuses(buses);
      setTotalBusesCount(buses.length);

    } catch (err) {
      console.error('Error fetching bus owners:', err);
    } finally {
      setLoading(false);
    }
  };

  const indexOfLastBus = currentPage * busesPerPage;
  const indexOfFirstBus = indexOfLastBus - busesPerPage;
  const currentBuses = filteredBuses.slice(indexOfFirstBus, indexOfLastBus);
  const totalPages = Math.ceil(filteredBuses.length / busesPerPage);

  const currentBusesWithSerial = currentBuses.map((bus, index) => ({
    ...bus,
    serialNo: indexOfFirstBus + index + 1
  }));

  const handleViewBus = (bus) => {
    setViewingBus(bus);
  };

  const closeViewModal = () => {
    setViewingBus(null);
  };

  const handleOpenSeatStatus = (bus) => {
    console.log("Opening seat status for bus:", bus);
    console.log("Route schedules:", bus.routeSchedules);
    setSeatStatusBus(bus);
  };

  const closeSeatStatusModal = () => {
    setSeatStatusBus(null);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleRefresh = async () => {
    setSearchTerm('');
    setCurrentPage(1);
    await fetchAllBusOwners();
  };

  const handleExportCSV = () => {
    if (filteredBuses.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = ['Serial No.', 'Bus Number', 'Bus Name', 'Bus Type', 'Category',
                     'Total Seats', 'Available Seats', 'Owner Name', 'Owner Phone',
                     'Owner Company', 'Status'];
    const csvData = filteredBuses.map((bus, index) => [
      index + 1,
      bus.busNumber,
      bus.busName,
      bus.busType,
      bus.busCategory,
      bus.totalSeats,
      bus.availableSeats,
      bus.ownerName || 'N/A',
      bus.ownerPhone || 'N/A',
      bus.ownerCompany || 'N/A',
      bus.isActive ? 'Active' : 'Inactive'
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `buses-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    alert('CSV exported successfully!');
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const activeBuses = filteredBuses.filter(bus => bus.isActive).length;
  const totalSeats = filteredBuses.reduce((sum, bus) => sum + (bus.totalSeats || 0), 0);
  const uniqueBusOwners = new Set(filteredBuses.map(bus => bus.ownerId)).size;

  if (loading && allBusesData.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Bus Management</h1>
        <div className="header-actions">
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder="Search by bus number, name, owner name or phone..."
              className="search-input"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "300px" }}
            />
          </div>
          <button className="refresh-btn" onClick={handleRefresh}>
            Refresh
          </button>
          <button className="export-btn" onClick={handleExportCSV}>
            Export CSV
          </button>
        </div>
      </div>

      <div className="stats-cards">
        <div className="stat-card">
          <h3>Total Buses</h3>
          <p>{totalBusesCount}</p>
          <span>All registered buses</span>
        </div>
        <div className="stat-card">
          <h3>Active Buses</h3>
          <p>{activeBuses}</p>
          <span>Currently active</span>
        </div>
        <div className="stat-card">
          <h3>Total Seats</h3>
          <p>{totalSeats}</p>
          <span>Across all buses</span>
        </div>
        <div className="stat-card">
          <h3>Bus Owners</h3>
          <p>{uniqueBusOwners}</p>
          <span>Unique owners</span>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Bus Number</th>
              <th>Bus Name</th>
              <th>Bus Type</th>
              <th>Category</th>
              <th>Total Seats</th>
              <th>Available Seats</th>
              <th>Owner Name</th>
              <th>Owner Phone</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentBusesWithSerial.length > 0 ? (
              currentBusesWithSerial.map(bus => (
                <tr key={bus.id}>
                  <td>{bus.serialNo}</td>
                  <td>
                    <span style={{ fontWeight: '600', color: '#0f6fbf' }}>
                      {bus.busNumber}
                    </span>
                  </td>
                  <td>{bus.busName}</td>
                  <td>
                    <span className={`bus-type-badge ${bus.busType === 'AC' ? 'ac' : 'non-ac'}`}>
                      {bus.busType}
                    </span>
                  </td>
                  <td>
                    <span className="bus-category-badge">
                      {bus.busCategory}
                    </span>
                  </td>
                  <td>{bus.totalSeats}</td>
                  <td>
                    <div className="available-seats-cell">
                      <button
                        className="action-btn live-seat-btn"
                        onClick={() => handleOpenSeatStatus(bus)}
                        title="View live seat status for a selected date"
                        style={{ backgroundColor: "#808080" }}
                      >
                        Live Seat Status
                      </button>
                    </div>
                  </td>
                  <td>
                    <div>
                      <strong>{bus.ownerName}</strong>
                      {bus.ownerCompany && (
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          {bus.ownerCompany}
                        </div>
                      )}
                    </div>
                  </td>
                  <td>{bus.ownerPhone}</td>
                  <td>
                    <span className={`status-badge ${bus.isActive ? 'active' : 'inactive'}`}>
                      {bus.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn view"
                        onClick={() => handleViewBus(bus)}
                      >
                        View
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="no-data">
                  <p>No buses found {searchTerm ? 'matching your search' : ''}.</p>
                  {searchTerm && (
                    <button className="clear-filters-link" onClick={handleRefresh}>
                      Clear search to see all buses
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {filteredBuses.length > 0 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {indexOfFirstBus + 1} to {Math.min(indexOfLastBus, filteredBuses.length)} of {filteredBuses.length} buses
            {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
          </div>
          <div className="pagination-controls">
            <button
              className="pagination-btn"
              onClick={handlePrevPage}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <div className="page-numbers">
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                let pageNumber;
                if (totalPages <= 5) {
                  pageNumber = i + 1;
                } else if (currentPage <= 3) {
                  pageNumber = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNumber = totalPages - 4 + i;
                } else {
                  pageNumber = currentPage - 2 + i;
                }

                return (
                  <button
                    key={pageNumber}
                    className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageClick(pageNumber)}
                  >
                    {pageNumber}
                  </button>
                );
              })}
            </div>

            <button
              className="pagination-btn"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* View Bus Modal */}
      {viewingBus && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content1 view-route-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Bus Details: {viewingBus.busNumber}</h3>
              <button className="modal-close-btn" onClick={closeViewModal}>
                ×
              </button>
            </div>

            <div className="modal-body view-modal-body">
              <div className="route-details">
                <div className="detail-section">
                  <h4>Bus Information</h4>
                  <div className="detail-row">
                    <label>Bus Number:</label>
                    <span style={{ fontWeight: 'bold', color: '#007bff' }}>{viewingBus.busNumber}</span>
                  </div>
                  <div className="detail-row">
                    <label>Bus Name:</label>
                    <span>{viewingBus.busName}</span>
                  </div>
                  <div className="detail-row">
                    <label>Bus Type:</label>
                    <span className={`bus-type-badge ${viewingBus.busType === 'AC' ? 'ac' : 'non-ac'}`}>
                      {viewingBus.busType}
                    </span>
                  </div>
                  <div className="detail-row">
                    <label>Bus Category:</label>
                    <span>{viewingBus.busCategory}</span>
                  </div>
                  <div className="detail-row">
                    <label>Total Seats:</label>
                    <span>{viewingBus.totalSeats}</span>
                  </div>
                  <div className="detail-row">
                    <label>Available Seats:</label>
                    <span>{viewingBus.availableSeats}</span>
                  </div>
                  <div className="detail-row">
                    <label>Status:</label>
                    <span className={`status-badge ${viewingBus.isActive ? 'active' : 'inactive'}`}>
                      {viewingBus.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>

                {viewingBus.amenities && viewingBus.amenities.length > 0 && (
                  <div className="detail-section">
                    <h4>Amenities</h4>
                    <div className="amenities-list">
                      {viewingBus.amenities.map((amenity, index) => (
                        <span key={index} className="amenity-badge">
                          {amenity}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {viewingBus.operatingDays && viewingBus.operatingDays.length > 0 && (
                  <div className="detail-section">
                    <h4>Operating Days</h4>
                    <div className="operating-days-list">
                      {viewingBus.operatingDays.map((day, index) => (
                        <span key={index} className="day-badge">
                          {day}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {viewingBus.driver && (
                  <div className="detail-section">
                    <h4>Driver Information</h4>
                    <div className="detail-row">
                      <label>Driver Name:</label>
                      <span>{viewingBus.driver.name || 'N/A'}</span>
                    </div>
                    <div className="detail-row">
                      <label>Driver Phone:</label>
                      <span>{viewingBus.driver.mobileNumber || 'N/A'}</span>
                    </div>
                    <div className="detail-row">
                      <label>License Number:</label>
                      <span>{viewingBus.driver.licenseNumber || 'N/A'}</span>
                    </div>
                  </div>
                )}

                {viewingBus.conductor && (
                  <div className="detail-section">
                    <h4>Conductor Information</h4>
                    <div className="detail-row">
                      <label>Conductor Name:</label>
                      <span>{viewingBus.conductor.name || 'N/A'}</span>
                    </div>
                    <div className="detail-row">
                      <label>Conductor Phone:</label>
                      <span>{viewingBus.conductor.mobileNumber || 'N/A'}</span>
                    </div>
                  </div>
                )}

                <div className="detail-section">
                  <h4>Owner Information</h4>
                  <div className="detail-row">
                    <label>Owner Name:</label>
                    <span><strong>{viewingBus.ownerName}</strong></span>
                  </div>
                  <div className="detail-row">
                    <label>Phone Number:</label>
                    <span>{viewingBus.ownerPhone}</span>
                  </div>
                  {viewingBus.ownerEmail && (
                    <div className="detail-row">
                      <label>Email:</label>
                      <span>{viewingBus.ownerEmail}</span>
                    </div>
                  )}
                  {viewingBus.ownerCompany && (
                    <div className="detail-row">
                      <label>Company:</label>
                      <span>{viewingBus.ownerCompany}</span>
                    </div>
                  )}
                  {viewingBus.ownerAddress && (
                    <div className="detail-row">
                      <label>Address:</label>
                      <span>
                        {viewingBus.ownerAddress.city}, {viewingBus.ownerAddress.state}
                        {viewingBus.ownerAddress.pincode && ` - ${viewingBus.ownerAddress.pincode}`}
                      </span>
                    </div>
                  )}
                  <div className="detail-row">
                    <label>Commission:</label>
                    <span>{viewingBus.ownerCommissionRate}% ({viewingBus.ownerCommissionType})</span>
                  </div>
                  <div className="detail-row">
                    <label>Verification Status:</label>
                    <span className={`status-badge ${viewingBus.ownerIsVerified ? 'active' : 'inactive'}`}>
                      {viewingBus.ownerIsVerified ? 'Verified' : 'Unverified'}
                    </span>
                  </div>
                  <div className="detail-row">
                    <label>Admin Approval:</label>
                    <span className={`status-badge ${viewingBus.ownerIsApproved ? 'active' : 'inactive'}`}>
                      {viewingBus.ownerIsApproved ? 'Approved' : 'Pending'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="modal-close-btn secondary" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Live Seat Status Modal */}
      {seatStatusBus && (
        <LiveSeatStatusModal
          bus={seatStatusBus}
          token={token}
          onClose={closeSeatStatusModal}
        />
      )}
    </div>
  );
};

export default BusManagement;